import type { Template } from "@/types";

export const LA_04_H3_V1: Template[] = [
{
    id: "la-04-h3v1-01",
    name: "LA 01 - H3V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 170, y: 37, width: 299, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 838, y: 37, width: 237, height: 131, rotation: 0, imageRotation: 0 },
            { id: "3", x: 838, y: 174, width: 237, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 838, y: 311, width: 237, height: 130, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h3v1-02",
    name: "LA 02 - H3V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 167, y: 34, width: 303, height: 407, rotation: 0, imageRotation: 0 },
            { id: "2", x: 736, y: 201, width: 439, height: 239, rotation: 0, imageRotation: 0 },
            { id: "3", x: 736, y: 35, width: 217, height: 159, rotation: 0, imageRotation: 0 },
            { id: "4", x: 959, y: 35, width: 216, height: 159, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h3v1-03",
    name: "LA 03 - H3V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 36, y: 35, width: 304, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1033, y: 35, width: 205, height: 130, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1033, y: 173, width: 205, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1033, y: 310, width: 205, height: 129, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h3v1-04",
    name: "LA 04 - H3V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 122, y: 36, width: 395, height: 261, rotation: 0, imageRotation: 0 },
            { id: "2", x: 122, y: 304, width: 194, height: 134, rotation: 0, imageRotation: 0 },
            { id: "3", x: 322, y: 304, width: 194, height: 134, rotation: 0, imageRotation: 0 },
            { id: "4", x: 806, y: 37, width: 299, height: 402, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h3v1-5",
    name: "LA 05 - H3V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 78, y: 65, width: 481, height: 348, rotation: 0, imageRotation: 0 },
            { id: "2", x: 707, y: 65, width: 256, height: 170, rotation: 0, imageRotation: 0 },
            { id: "3", x: 707, y: 243, width: 256, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 971, y: 65, width: 237, height: 348, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h3v1-06",
    name: "LA 06 - H3V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 187, width: 361, height: 249, rotation: 0, imageRotation: 0 },
            { id: "2", x: 368, y: 187, width: 361, height: 249, rotation: 0, imageRotation: 0 },
            { id: "3", x: 736, y: 187, width: 173, height: 249, rotation: 0, imageRotation: 0 },
            { id: "4", x: 916, y: 187, width: 364, height: 249, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h3v1-07",
    name: "LA 07 - H3V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 63, y: 117, width: 323, height: 243, rotation: 0, imageRotation: 0 },
            { id: "2", x: 394, y: 117, width: 323, height: 243, rotation: 0, imageRotation: 0 },
            { id: "3", x: 724, y: 117, width: 323, height: 243, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1054, y: 117, width: 157, height: 243, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h3v1-08",
    name: "LA 08 - H3V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 36, y: 31, width: 294, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 36, y: 242, width: 294, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 337, y: 31, width: 612, height: 412, rotation: 0, imageRotation: 0 },
            { id: "4", x: 956, y: 31, width: 282, height: 412, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h3v1-09",
    name: "LA 09 - H3V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 37, y: 31, width: 294, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 37, y: 242, width: 294, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 337, y: 31, width: 283, height: 412, rotation: 0, imageRotation: 0 },
            { id: "4", x: 627, y: 31, width: 612, height: 412, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h3v1-10",
    name: "LA 10 - H3V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 30, width: 319, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 241, width: 319, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 327, y: 30, width: 664, height: 413, rotation: 0, imageRotation: 0 },
            { id: "4", x: 999, y: 30, width: 275, height: 413, rotation: 0, imageRotation: 0 }
    ],
}
];